import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  panel_title:   "LUMEN",
  logo_url:      null,
  primary_color: "#F5A623",
};

const SettingsContext = createContext({
  ...DEFAULTS,
  loading: true,
  refresh: () => {},
});

export function SettingsProvider({ children }) {
  const [data, setData] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/settings/public");
      setData({
        panel_title:   res.data?.panel_title  || DEFAULTS.panel_title,
        logo_url:      res.data?.logo_url     || null,
        primary_color: res.data?.primary_color || DEFAULTS.primary_color,
      });
    } catch (err) {
      // Sessizce default'ları kullan — public endpoint çalışmadıysa bile UI çökmesin.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Document title + sekme ikonu / favicon başlığı sync
  useEffect(() => {
    if (data.panel_title) {
      document.title = `${data.panel_title} — IPTV Control`;
    }
  }, [data.panel_title]);

  return (
    <SettingsContext.Provider value={{ ...data, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
